import { render, staticRenderFns } from "./SeatOverlayInformation.vue?vue&type=template&id=510a8763&"
import script from "./SeatOverlayInformation.vue?vue&type=script&lang=js&"
export * from "./SeatOverlayInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports